import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/about/block2-数字人直播图.png")